var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fillColor",
    id: "Validation-sidebar-/-Lo-que-ve-nivel-2",
    transform: "translate(-39.000000, -142.000000)",
    fill: "#7B8989",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "periodicity",
    transform: "translate(18.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-undo",
    transform: "translate(21.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34237564,9.34618527 L2.97654583,5.99985381 L2.97654583,5.99985381 L6.35203009,2.64416912 C6.71060094,2.28770153 6.71426299,1.70866111 6.36022949,1.34768677 C6.01309463,0.993746313 5.44476079,0.98822929 5.09082034,1.33536415 C5.08703841,1.33907336 5.08328938,1.34281598 5.07957371,1.34659156 L1.18784339,5.30106677 C0.805801176,5.68926851 0.804691496,6.31181968 1.18534737,6.70138091 L5.07236154,10.6793308 C5.41777425,11.0328244 5.98434974,11.0393752 6.3378433,10.6939625 C6.34543928,10.6865401 6.35290252,10.6789832 6.36022949,10.6712952 C6.71573126,10.2982761 6.70779827,9.709491 6.34237564,9.34618527 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,5 L2,5 L2,7 L14,7 C16.2553594,7 18,8.60217804 18,11 C18,13.397822 16.2553594,15 14,15 L3,15 C2.44771525,15 2,15.4477153 2,16 C2,16.5522847 2.44771525,17 3,17 L14,17 L14,17 C17.1113984,17 20,14.3082604 20,11 C20,7.69173961 17.1116582,5 14,5 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.5ade0effcc920a01ab0d6437457fe696.svg";
export { ForwardRef as ReactComponent };